import 'babel-polyfill'; // polyfill 解决兼容性问题
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './router/permission';
import store from './store';
import './utils/flexible';
import './styles/reset.css';
import './styles/vant.less';
// import './assets/fonts/iconfont.css';

// 挂到原型上的对象或函数 -----------------------------------------------------
import request from './request'; // 接口对象
Vue.prototype.$request = request;

import * as utils from './utils'; // 工具函数
Vue.prototype.$utils = utils;

// import * as datas from './datas'; // 静态数据
// Vue.prototype.$datas = datas;

Vue.prototype.console = console; // console方法

// vant -----------------------------------------------------
import {
  Toast,
  Button,
  Tab,
  Tabs,
  Form,
  Field,
  NavBar,
  Icon,
  Swipe,
  SwipeItem,
  Popup,
  Sidebar,
  SidebarItem,
  Loading,
  Collapse,
  CollapseItem,
  ImagePreview,
  Notify
} from 'vant';

Vue.use(Toast);
Vue.use(Button);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Loading);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ImagePreview);
Vue.use(Notify);

Vue.prototype.$toast = Toast;

// new Vue -----------------------------------------------------
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
